import CertsDecommissionAction from './CertsDecommissionAction';

export default CertsDecommissionAction;
